import * as Sentry from "@sentry/browser";
import React, { useRef } from "react";
import { isEqual } from "lodash";

import { useConfig } from "./config";

interface SentryProps {
  children?: React.ReactNode;
}

export function SentryProvider(props: SentryProps) {
  const { children } = props;
  const config = useConfig();
  const prevConfig = useRef<object>({});

  React.useEffect(() => {
    if (!isEqual(config, prevConfig.current)) {
      prevConfig.current = config;
      Sentry.init({
        dsn: config.sentryDSN,
        environment: config.environment,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            blockAllMedia: true,
            maskAllText: false,
            maskAllInputs: false,
          }),
        ],
        ignoreErrors: [
          "TypeError: Failed to fetch",
          "TypeError: Cannot read properties of undefined (reading 'spaceID')",
          "jQuery",
          "Chartboost",
        ],
        denyUrls: [/localhost/i],
        enabled: config.environment !== "development",
      });
    }
  }, [config]);

  return <>{children}</>;
}
